declare var google: any;

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GoogleTranslateService {

  loadScript() {
    return new Promise<void>((resolve) => {

      if (document.getElementById('google-translate-script')) {
        resolve();
        return;
      }

      (window as any).googleTranslateElementInit = () => {
        new google.translate.TranslateElement(
          {
            pageLanguage: 'en',
            autoDisplay: false
          },
          'google_translate_element'
        );
        resolve();
      };

      const script = document.createElement('script');
      script.id = 'google-translate-script';
      script.src =
        'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;

      document.body.appendChild(script);
    });
  }
}